import Extended from '@pages/Checkout/Extras/Ancillary/Extended'
import Resolver from '@pages/Checkout/Extras/Ancillary/Resolver'

const AncillaryBase = {
  Extended,
  Resolver,
}

export default AncillaryBase
